import EstimateCompanyContent from './EstimateCompanyContent'
import EstimateCompanyController from './EstimateCompanyController'

export { default } from './EstimateCompany'

export const EstimateCompanyMapConfig = {
  Content: EstimateCompanyContent,
  Controller: EstimateCompanyController,
}
